"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergePreservingTarget = exports.getAccompanyingReportRoute = exports.getAFormsForProjectFormCategory = exports.getBFormsForProjectFormCategory = exports.getProjectFormTypeSectionsForCategory = exports.projectFormEnumToProjectFormType = exports.projectFormEnumToProjectFormCategory = exports.projectFormTypeToTypeNameAndLaw = exports.deepPartial = exports.makeSchemaOptional = exports.getProjectFormIdentifier = exports.getProjectFormNameBasedOnType = exports.generateRandomString = exports.dumpTest = void 0;
const enums_1 = require("./enums");
const zod_1 = require("zod");
const technicalFormConstants_1 = require("./technicalFormConstants");
const dumpTest = () => {
    console.log("Hello world");
};
exports.dumpTest = dumpTest;
function generateRandomString(length = 8) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
exports.generateRandomString = generateRandomString;
function getProjectFormNameBasedOnType(type) {
    switch (type) {
        case enums_1.ProjectFormEnum.ACCOMPANYING_REPORT_FORM_A1:
        case enums_1.ProjectFormEnum.DEMOLITION_ACCOMPANYING_REPORT_FORM_A1:
            return "Průvodní list";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B1:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B1:
            return "Celkový popis území a stavby";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B2:
            return "Urbanistické a základní architektonické řešení";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B3:
            return "Základní stavebně technické a technologické řešení";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B4:
            return "Připojení na technickou infrastrukturu";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B5:
            return "Dopravní řešení";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B6:
            return "Řešení vegetace a souvisejících terénních úprav";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B7:
            return "Popis vlivů stavby na životní prostředí";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B8:
            return "Celkové vodohospodářské řešení";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B9:
            return "Ochrana obyvatelstva";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B10:
            return "Zásady organizace výstavby";
        case enums_1.ProjectFormEnum.CONSTRUCTION_DIARY_FORM:
            return "Stavební deník";
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B2:
            return "Připojení na technickou infrastrukturu";
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B3:
            return "Úpravy terénu a řešení vegetace po odstranění stavby";
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B4:
            return "Zásady organizace bouracích prací";
        default:
            throw new Error("getProjectFormNameBasedOnType - Unknown Project Form Type " + type);
    }
}
exports.getProjectFormNameBasedOnType = getProjectFormNameBasedOnType;
function getProjectFormIdentifier(type) {
    switch (type) {
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B1:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B1:
            return "B 1";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B2:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B2:
            return "B 2";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B3:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B3:
            return "B 3";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B4:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B4:
            return "B 4";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B5:
            return "B 5";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B6:
            return "B 6";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B7:
            return "B 7";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B8:
            return "B 8";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B9:
            return "B 9";
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B10:
            return "B 10";
        case enums_1.ProjectFormEnum.ACCOMPANYING_REPORT_FORM_A1:
        case enums_1.ProjectFormEnum.DEMOLITION_ACCOMPANYING_REPORT_FORM_A1:
            return "A";
        case enums_1.ProjectFormEnum.CONSTRUCTION_DIARY_FORM:
            return "Stavební deník";
        default:
            throw new Error("getProjectFormIdentifier - Unknown Project Form Type " + type);
    }
}
exports.getProjectFormIdentifier = getProjectFormIdentifier;
const makeSchemaOptional = (schema) => {
    if (schema instanceof zod_1.z.ZodObject) {
        const newShape = Object.fromEntries(Object.entries(schema.shape).map(([key, value]) => [
            key,
            (0, exports.makeSchemaOptional)(value)
        ]));
        return zod_1.z.object(newShape).partial();
    }
    else if (schema instanceof zod_1.z.ZodArray) {
        return zod_1.z.array((0, exports.makeSchemaOptional)(schema.element));
    }
    else {
        return schema.optional();
    }
};
exports.makeSchemaOptional = makeSchemaOptional;
const deepPartial = (schema) => {
    if (schema instanceof zod_1.z.ZodObject) {
        const newShape = Object.fromEntries(Object.entries(schema.shape).map(([key, value]) => [
            key,
            (0, exports.deepPartial)(value)
        ]));
        return zod_1.z.object(newShape).optional();
    }
    return schema.optional();
};
exports.deepPartial = deepPartial;
const projectFormTypeToTypeNameAndLaw = (type) => {
    switch (type) {
        case enums_1.ProjectFormTypeEnum.BUILDING_PERMIT_ACCOMPANYING_REPORT:
        case enums_1.ProjectFormTypeEnum.DEMOLITION_PERMIT_ACCOMPANYING_REPORT:
            return {
                name: "Průvodní list",
                law: "Dle vyhlášky č. 131/2024 Sb."
            };
        case enums_1.ProjectFormTypeEnum.BUILDING_PERMIT_TECHNICAL_FORM:
        case enums_1.ProjectFormTypeEnum.DEMOLITION_PERMIT_TECHNICAL_FORM:
            return {
                name: "Souhrnná technická zpráva",
                law: "Dle vyhlášky č. 131/2024 Sb."
            };
        default:
            throw new Error(`projectFormTypeToTypeNameAndLaw - Unknown Project Form Type ${type}`);
    }
};
exports.projectFormTypeToTypeNameAndLaw = projectFormTypeToTypeNameAndLaw;
const projectFormEnumToProjectFormCategory = (projectForm) => {
    switch (projectForm) {
        case enums_1.ProjectFormEnum.ACCOMPANYING_REPORT_FORM_A1:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B1:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B2:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B3:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B4:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B5:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B6:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B7:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B8:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B9:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B10:
            return enums_1.ProjectFormCategoryEnum.BUILDING_PERMIT;
        case enums_1.ProjectFormEnum.DEMOLITION_ACCOMPANYING_REPORT_FORM_A1:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B1:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B2:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B3:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B4:
            return enums_1.ProjectFormCategoryEnum.DEMOLITION_PERMIT;
        default:
            throw new Error(`projectFormEnumToProjectFormCategory - Unknown Project Form Type ${projectForm}`);
    }
};
exports.projectFormEnumToProjectFormCategory = projectFormEnumToProjectFormCategory;
const projectFormEnumToProjectFormType = (projectForm) => {
    switch (projectForm) {
        case enums_1.ProjectFormEnum.ACCOMPANYING_REPORT_FORM_A1:
            return enums_1.ProjectFormTypeEnum.BUILDING_PERMIT_ACCOMPANYING_REPORT;
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B1:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B2:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B3:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B4:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B5:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B6:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B7:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B8:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B9:
        case enums_1.ProjectFormEnum.TECHNICAL_FORM_B10:
            return enums_1.ProjectFormTypeEnum.BUILDING_PERMIT_ACCOMPANYING_REPORT;
        case enums_1.ProjectFormEnum.DEMOLITION_ACCOMPANYING_REPORT_FORM_A1:
            return enums_1.ProjectFormTypeEnum.DEMOLITION_PERMIT_ACCOMPANYING_REPORT;
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B1:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B2:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B3:
        case enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B4:
            return enums_1.ProjectFormTypeEnum.DEMOLITION_PERMIT_TECHNICAL_FORM;
        default:
            throw new Error(`projectFormEnumToProjectFormType - Unknown Project Form Type ${projectForm}`);
    }
};
exports.projectFormEnumToProjectFormType = projectFormEnumToProjectFormType;
const getProjectFormTypeSectionsForCategory = (projectFormCategory) => {
    switch (projectFormCategory) {
        case enums_1.ProjectFormCategoryEnum.BUILDING_PERMIT:
            return {
                a: enums_1.ProjectFormTypeEnum.BUILDING_PERMIT_ACCOMPANYING_REPORT,
                b: enums_1.ProjectFormTypeEnum.BUILDING_PERMIT_TECHNICAL_FORM
            };
        case enums_1.ProjectFormCategoryEnum.DEMOLITION_PERMIT:
            return {
                a: enums_1.ProjectFormTypeEnum.DEMOLITION_PERMIT_ACCOMPANYING_REPORT,
                b: enums_1.ProjectFormTypeEnum.DEMOLITION_PERMIT_TECHNICAL_FORM
            };
        default:
            throw new Error(`Unknown Project Form Category ${projectFormCategory}`);
    }
};
exports.getProjectFormTypeSectionsForCategory = getProjectFormTypeSectionsForCategory;
const getBFormsForProjectFormCategory = (category) => {
    switch (category) {
        case enums_1.ProjectFormCategoryEnum.BUILDING_PERMIT:
            return technicalFormConstants_1.BUILDING_PERMIT_B_FORMS;
        case enums_1.ProjectFormCategoryEnum.DEMOLITION_PERMIT:
            return technicalFormConstants_1.DEMOLITION_PERMIT_B_FORMS;
    }
};
exports.getBFormsForProjectFormCategory = getBFormsForProjectFormCategory;
const getAFormsForProjectFormCategory = (category) => {
    switch (category) {
        case enums_1.ProjectFormCategoryEnum.BUILDING_PERMIT:
            return technicalFormConstants_1.BUILDING_PERMIT_A_FORMS;
        case enums_1.ProjectFormCategoryEnum.DEMOLITION_PERMIT:
            return technicalFormConstants_1.DEMOLITION_PERMIT_A_FORMS;
    }
};
exports.getAFormsForProjectFormCategory = getAFormsForProjectFormCategory;
/**
 * Maps project form category to its corresponding accompanying report route suffix
 * This is used for generating navigation URLs to the correct accompanying report form
 */
const getAccompanyingReportRoute = (category) => {
    switch (category) {
        case enums_1.ProjectFormCategoryEnum.BUILDING_PERMIT:
            return 'accompanying-report';
        case enums_1.ProjectFormCategoryEnum.DEMOLITION_PERMIT:
            return 'demolition-accompanying-report';
        default:
            throw new Error(`Unknown project form category: ${category}`);
    }
};
exports.getAccompanyingReportRoute = getAccompanyingReportRoute;
/**
 * Checks if a value is considered "empty" for the purpose of merging.
 * Empty values are: null, undefined, empty string (after trim), empty array, or empty object.
 * @param {*} value - The value to check.
 * @returns {boolean} True if the value is considered empty, false otherwise.
 */
function isConsideredEmpty(value) {
    if (value === null || value === undefined) {
        return true;
    }
    if (typeof value === 'string' && value.trim() === '') {
        return true;
    }
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
        return true;
    }
    return false;
}
/**
 * Deeply merges a source object into a target object with a specific rule:
 * It does not overwrite a "filled" value in the target with an "empty" value
 * (null, undefined, "", [], {}) from the source.
 *
 * @param {object} target - The target object (e.g., currentFormValues).
 * @param {object} source - The source object (e.g., aiFormValues).
 * @returns {object} A new object representing the merged result.
 */
function mergePreservingTarget(target, source) {
    // Start with a shallow clone of the target to preserve its properties and ensure a new object is returned.
    const output = Object.assign({}, target);
    if (typeof source !== 'object' || source === null) {
        // If source is not an object (e.g., an error or unexpected input), return the cloned target.
        return output;
    }
    if (typeof target !== 'object' || target === null) {
        // If target is not an object, and source is, effectively deep clone source respecting its own empty rules.
        // This path is less common if currentFormValues is always an object.
        return mergePreservingTarget({}, source);
    }
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            const sourceValue = source[key];
            const targetValue = target[key]; // Value from the original target for comparison
            const isSourceValueEmpty = isConsideredEmpty(sourceValue);
            // A target value is "filled" if it exists and is not itself considered empty.
            const isTargetValueFilled = targetValue !== undefined && !isConsideredEmpty(targetValue);
            if (typeof sourceValue === 'object' && sourceValue !== null && !Array.isArray(sourceValue)) {
                // Source value is an object.
                if (isSourceValueEmpty && isTargetValueFilled) {
                    // Source provides an empty object (e.g., {}), but target has filled content for this key.
                    // Keep the target's filled content. `output[key]` already has `targetValue`.
                    continue;
                }
                if (typeof targetValue === 'object' && targetValue !== null && !Array.isArray(targetValue)) {
                    // Both source and target have an object for this key; recurse.
                    output[key] = mergePreservingTarget(targetValue, sourceValue);
                }
                else {
                    // Source has an object, but target does not (or has a primitive/array).
                    // If the source object is not empty, it should be set.
                    // We recursively call mergePreservingTarget with an empty object as the new base
                    // to ensure the source object's structure is deeply cloned and its own empty rules are respected.
                    if (!isSourceValueEmpty) {
                        output[key] = mergePreservingTarget({}, sourceValue);
                    }
                    else {
                        // Source has an empty object, and target is not a filled object (could be undefined, null, primitive, or empty object/array).
                        // If targetValue was filled (e.g. a primitive), the `isSourceValueEmpty && isTargetValueFilled`
                        // check above for objects would have caught it if targetValue was also an object.
                        // If targetValue is a filled primitive, that condition wouldn't apply here.
                        // However, the more general check below for primitives will handle that.
                        // If we are here: source is {} and target is not a filled object.
                        // If targetValue is a filled *primitive/array*, the generic `isSourceValueEmpty && isTargetValueFilled` check for *any* type
                        // at the start of the loop for primitive/array types handles this.
                        // This specific object block's `isSourceValueEmpty && isTargetValueFilled` handles `source: {key: {}}` and `target: {key: {a:1}}`.
                        // If `source: {key: {}}` and `target: {key: "filled_string"}`, the general check for primitive/array applies.
                        // So, if sourceValue is an empty object and targetValue is NOT a filled object,
                        // we just assign the empty object from source.
                        output[key] = sourceValue; // Assigns the empty object from source
                    }
                }
            }
            else if (Array.isArray(sourceValue)) {
                // Source value is an array.
                if (isSourceValueEmpty && isTargetValueFilled) {
                    // Source provides an empty array (e.g., []), but target has a filled array/value.
                    // Keep the target's filled content.
                    continue;
                }
                // If source array is not empty, or if target is empty/not present, assign a copy of the source array.
                // This replaces the target array; it does not merge array elements.
                output[key] = [...sourceValue]; // Shallow copy of the array
            }
            else {
                // Source value is a primitive (string, number, boolean, null, undefined).
                if (isSourceValueEmpty && isTargetValueFilled) {
                    // Source provides an empty primitive (e.g., "" or null), but target has a filled value.
                    // Keep the target's filled value.
                    continue;
                }
                // Otherwise (source value is not empty OR target value is not filled), assign source value.
                output[key] = sourceValue;
            }
        }
    }
    return output;
}
exports.mergePreservingTarget = mergePreservingTarget;
